"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const Metric_1 = require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/Metric");
const MetricCategory_1 = __importDefault(require("@becrop/components/Toolkit/MetricsBoxPlot/models/evolution/MetricCategory"));
const sleep_1 = __importDefault(require("@common/tsutils/sleep"));
const lodash_1 = __importDefault(require("lodash"));
const METRICS_CATEGORIES = [
    {
        id: 'all',
        // Empty means all
        codes: [],
    },
    {
        id: 'hlt',
        codes: ['HLT', 'GS@HLT'],
    },
    {
        id: 'bio',
        codes: ['SHI@SHI', 'GS@ITB', 'GS@IFB', 'GS@IRE', 'GS@IRL'],
    },
    {
        id: 'pb',
        codes: ['BIO', 'GS@BIO'],
    },
    {
        id: 'pe',
        codes: ['STR', 'HOM', 'GS@HOM', 'GS@STR'],
    },
    {
        id: 'c',
        codes: ['NF-C'],
    },
    {
        id: 'npk',
        codes: ['NF-N', 'NF-P', 'NF-K'],
    },
    {
        id: 'nt',
        codes: ['Fe', 'Cl', 'S', 'Mg', 'Zn', 'Cu', 'Ca', 'Mn'].map((n) => `NF-${n}`),
    },
];
class BoxPlotEvolution {
    constructor() {
        this.clusters = [];
        this.metrics = [];
        this.bioMetrics = [];
        this.phchMetrics = [];
        this.categories = [];
        this.phchCategories = [];
        this.loaded = false;
        this.loadedPercentage = 0.0;
        this.dimension = 'bio';
        this.categories = METRICS_CATEGORIES.map((METRIC) => {
            return new MetricCategory_1.default(this, METRIC.id, METRIC.codes);
        });
        this.phchCategories.push(new MetricCategory_1.default(this, 'phch', ['phch']));
        this.isPhchDimension = false;
    }
    setClusters(clusterA, clustersB) {
        this.clusters = [clusterA, clustersB];
    }
    setDimension(dimension) {
        this.dimension = dimension;
        if (this.dimension === 'bio') {
            this.metrics = this.bioMetrics;
        }
        if (this.dimension === 'phch') {
            this.metrics = this.phchMetrics;
        }
    }
    getClusterPayload() {
        return this.clusters.map((cluster) => {
            return cluster.samples.map((s) => s.code);
        });
    }
    async load() {
        await this.loadMetricList();
        await this.loadAllMetrics();
        this.loaded = true;
        this.loadedPercentage = 1.0;
        console.log(this.metrics, 'METRICS');
    }
    async loadMetricList() {
        const data = {
            clusters: this.getClusterPayload(),
        };
        const response = await axios_1.default.post('/toolkit/wbp_metrics/metricList', data);
        const rawMicrobiological = response.data.microbiological;
        this.bioMetrics = rawMicrobiological.map((raw) => new Metric_1.Metric(this, raw, 'bio'));
        const rawPhCh = response.data.phch;
        if (rawPhCh.length > 0) {
            this.isPhchDimension = true;
        }
        this.phchMetrics = rawPhCh.map((raw) => new Metric_1.Metric(this, raw, 'phch'));
        if (this.dimension === 'bio') {
            this.metrics = this.bioMetrics;
        }
        else {
            this.metrics = this.phchMetrics;
        }
    }
    async loadAllMetrics() {
        this.loadedPercentage = 0;
        let i = 0;
        for (const chunk of lodash_1.default.chunk(this.metrics, 10)) {
            await Metric_1.Metric.load(chunk, 'bio');
            i += chunk.length;
            this.loadedPercentage = i / this.metrics.length;
        }
        // Filter
        this.metrics = this.metrics.filter((m) => m.bothHaveSamples() && m.atLeastOneSampleDetectedInAnyCluster());
        await (0, sleep_1.default)(500);
        this.categories.forEach((c) => c.init(this.metrics, 'bio'));
        this.loadedPercentage = 1;
        // phch
        if (this.phchMetrics.length > 0)
            await Metric_1.Metric.load(this.phchMetrics, 'phch');
        this.phchCategories.forEach((c) => c.init(this.phchMetrics, 'phch'));
    }
    getMetricCategory(id) {
        if (this.dimension === 'bio') {
            const cat = this.categories.find((c) => c.id === id);
            if (!cat) {
                throw new Error(`Missing category ${id}`);
            }
            return cat;
        }
        if (this.dimension === 'phch') {
            //phch
            const cat = this.phchCategories.find((c) => c.id === id);
            if (!cat) {
                throw new Error(`Missing category ${id}`);
            }
            return cat;
        }
    }
}
exports.default = BoxPlotEvolution;
